/** @module Specification/BOM/RefMaterialSupplier */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/def/Action",
	"csi/def/ViewRef",
	"csi/heading/Ref"
], function(declare,lang,csi,Action,ViewRef,Ref) {

	return declare(Ref, {
		/**
		 * @override
		 * Prevent editing of material supplier if product is empty
		 */
		_getRenderAction: function(ctx, h) {
			var material = ctx.getNodeContext().Actual;
			if (material == csi.EMPTY_URL) {
				return null;
			}

			return this.inherited(arguments);
		},

		/**
		 * @override
		 * Creates an action to select material suppliers.
		 */
		_getStoreAction: function(ctx, h) {
			var partMaterial = ctx.getNodeContext();
			var productSourcingUrl = ctx.cache.getNode(partMaterial.Actual).ProductSourcing;
			
			return lang.mixin(new Action(), {
				urlContext: productSourcingUrl,
				m_viewRef: lang.mixin(new ViewRef(), {
					m_id: "ProductSources",
					m_url: productSourcingUrl
				})
			});
		}
	});
});